import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelPlanReviewExtractionMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type CancelPlanReviewExtractionMutation = { __typename?: 'mutation_root', update_plan_review_requirement_extractions_by_pk?: { __typename?: 'plan_review_requirement_extractions', id: any, status: string } | null };


export const CancelPlanReviewExtractionDocument = gql`
    mutation cancelPlanReviewExtraction($id: uuid!) {
  update_plan_review_requirement_extractions_by_pk(
    pk_columns: {id: $id}
    _set: {status: "CANCELLED"}
  ) {
    id
    status
  }
}
    `;
export type CancelPlanReviewExtractionMutationFn = Apollo.MutationFunction<CancelPlanReviewExtractionMutation, CancelPlanReviewExtractionMutationVariables>;

/**
 * __useCancelPlanReviewExtractionMutation__
 *
 * To run a mutation, you first call `useCancelPlanReviewExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlanReviewExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlanReviewExtractionMutation, { data, loading, error }] = useCancelPlanReviewExtractionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPlanReviewExtractionMutation(baseOptions?: Apollo.MutationHookOptions<CancelPlanReviewExtractionMutation, CancelPlanReviewExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPlanReviewExtractionMutation, CancelPlanReviewExtractionMutationVariables>(CancelPlanReviewExtractionDocument, options);
      }
export type CancelPlanReviewExtractionMutationHookResult = ReturnType<typeof useCancelPlanReviewExtractionMutation>;
export type CancelPlanReviewExtractionMutationResult = Apollo.MutationResult<CancelPlanReviewExtractionMutation>;
export type CancelPlanReviewExtractionMutationOptions = Apollo.BaseMutationOptions<CancelPlanReviewExtractionMutation, CancelPlanReviewExtractionMutationVariables>;